import { toSharedAssetsCdnUrl } from '@shared/utils/getS3AssetPath';
import { Icon } from './Icon';
import { ReactSVG } from 'react-svg';
import { reportMissingIconNameToSentry } from './iconHelpers';
import { FALLBACK_ICON } from '@shared/utils/testing/helpers/factories';

type FloorPlanIconsProps = {
  name: string;
  size?: number;
  style?: React.CSSProperties;
  testId?: string;
  className?: string;
} & Omit<React.ComponentProps<typeof Icon>, 'name' | 'style' | 'testId'>;

export const FloorPlanIcons = ({
  name,
  style,
  testId,
  className,
  ...rest
}: FloorPlanIconsProps) => {
  const imageSrc = toSharedAssetsCdnUrl(name);

  return (
    <ReactSVG
      {...rest}
      src={imageSrc}
      data-testid={testId}
      className={className}
      style={style}
      fallback={() => <Icon name={FALLBACK_ICON} />}
      onError={(e) => {
        reportMissingIconNameToSentry(`${name}, Error: ${e}`);
      }}
    />
  );
};
